module.exports = __webpack_public_path__ + "static/logo-0134539bb3021e06e05170aa1b12c366.png";